import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenAttendancesIndicatorC5Data } from "@/services/esus/indicator/esf/c5/getDetailedCitizensAttendancesIndicatorC5";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC5CitizenAttendancesHistoryItem } from "./IndicatorEsfC5CitizenAttendancesHistoryItem";
import { IndicatorEsfC5CitizenAttendancesHistoryInfo } from "./IndicatorEsfC5CitizenAttendancesHistoryInfo";

type IndicatorEsfC5CitizenAttendancesHistoryProps = {
	citizenWithAttendances: DetailedCitizenAttendancesIndicatorC5Data;
};

export function IndicatorEsfC5CitizenAttendancesHistory({
	citizenWithAttendances,
}: Readonly<IndicatorEsfC5CitizenAttendancesHistoryProps>) {
	const indicatorEsfC5CitizenHistoryInfo = {
		fullName: citizenWithAttendances.fullName ? citizenWithAttendances.fullName : "N/A",
		birthdate: citizenWithAttendances.birthdate
			? dayjs(citizenWithAttendances.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithAttendances.birthdate ? getAge(citizenWithAttendances.birthdate) : "N/A",
		document: citizenWithAttendances.cpf
			? formatIdentifier(citizenWithAttendances.cpf)
			: citizenWithAttendances.cns ?? "",
		motherName: citizenWithAttendances.motherName ?? "",
		phone: citizenWithAttendances.phone ? phoneFormat(citizenWithAttendances.phone) : "",
		address:
			addressConcat(
				citizenWithAttendances.street,
				citizenWithAttendances.houseNumber,
				citizenWithAttendances.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC5CitizenAttendancesHistoryInfo {...indicatorEsfC5CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Consultas"
				timeLineContents={(citizenWithAttendances.attendances ?? []).map<TimeLineContent>(
					(attendance) => {
						return {
							content: (
								<IndicatorEsfC5CitizenAttendancesHistoryItem
									attendance={attendance}
								/>
							),
							eventDate: attendance.date
								? dayjs(attendance.date).format("DD/MM/YYYY")
								: "N/A",
						};
					}
				)}
			/>
			<TimeLine
				timeLineTitle="Aferições de PA"
				timeLineContents={(
					citizenWithAttendances.bloodPressureMeasurements ?? []
				).map<TimeLineContent>((bloodPressureMeasurement) => {
					return {
						content: (
							<IndicatorEsfC5CitizenAttendancesHistoryItem
								attendance={bloodPressureMeasurement}
							/>
						),
						eventDate: bloodPressureMeasurement.date
							? dayjs(bloodPressureMeasurement.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
			<TimeLine
				timeLineTitle="Registros de Peso e Altura"
				timeLineContents={(
					citizenWithAttendances.weightAndHeightMetricsRegisters ?? []
				).map<TimeLineContent>((metricsAttendance) => {
					return {
						content: (
							<IndicatorEsfC5CitizenAttendancesHistoryItem
								attendance={metricsAttendance}
							/>
						),
						eventDate: metricsAttendance.date
							? dayjs(metricsAttendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
